if(!customElements.get('truncated-text')) {
  class ComponentTruncatedText extends HTMLElement {
    constructor() {
      super();
      this.truncatedText = this.querySelector('.truncated');
      this.fullText = this.querySelector('.full-text');
      this.showButton = this.querySelector('.show-btn');
      this.hideButton = this.querySelector('.hide-btn');

      this.showButton.addEventListener('click', ()=>{
        this.truncatedText.classList.add('hide');
        this.fullText.classList.remove('hide');
        this.showButton.classList.add('hide');
        this.hideButton.classList.remove('hide');

      });

      this.hideButton.addEventListener('click', ()=>{
        this.fullText.classList.add('hide');
        this.truncatedText.classList.remove('hide');
        this.showButton.classList.remove('hide');
        this.hideButton.classList.add('hide');

      });
    }
  

  }
  
  customElements.define('truncated-text', ComponentTruncatedText);}
